<template>
<div>
    <Breadcrumbs main="Sales"  title="Invoice" />

    <div class="invoice-container">
        <div style="display: flex; gap: 10px;">
            <div>
                <b-button variant="primary" @click="goBack">
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <feather type="arrow-left" size="18px"></feather>
                        <h7>Back</h7>
                    </div>
                </b-button> 
            </div>
            <b-button variant="primary" @click="editInvoice(invoiceData.invoice_id)">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="edit" size="18px"></feather>
                    <h7>Edit</h7>
                </div>
            </b-button>
            <b-button variant="primary" @click="showPDF">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="eye" size="18px"></feather>
                    <h7>Preview</h7>
                </div>
            </b-button>
            <b-button variant="primary" @click="generatePDF">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="printer" size="18px"></feather>
                    <h7>Download</h7>
                </div>
            </b-button>
        </div>
    </div>
    <div class="d-flex flex-row mb-4" style="gap: 10px;">

        <div class="d-flex flex-row">
            <h6 class=" align-content-center mr-2">Letter Head</h6>
            <div class="">
                <div class="text-right media-body icon-state switch-outline">
                    <label class="switch">
                        <input type="checkbox" :checked="showLetterHead" @click="toggleLetterHead"><span class="bg-primary switch-state"></span>
                    </label>
                </div>
            </div>
        </div>

        <div class="d-flex flex-row">
            <h6 class=" align-content-center mr-2">Logo</h6>
            <div class="">
                <div class="text-right media-body icon-state switch-outline">
                    <label class="switch">
                        <input type="checkbox" :checked="showLogo" @click="toggleLogo"><span class="bg-primary switch-state"></span>
                    </label>
                </div>
            </div>
        </div>

        <div class="d-flex flex-row">
            <h6 class=" align-content-center mr-2">Signature</h6>
            <div class="">
                <div class="text-right media-body icon-state switch-outline">
                    <label class="switch">
                        <input type="checkbox" :checked="showSignature" @click="toggleSignature"><span class="bg-primary switch-state"></span>
                    </label>
                </div>
            </div>
        </div>

    </div>
    <div class="row">
        <div class="col-xl-8">
            <div v-if="!loading && !error">
                <div :id="showPage ? '' : 'print'" ref="printDiv">

                    <div class="w-100 content-container">
                        <div class="mt-4 invoice-header">
                            <!-- Company info -->
                            <div style="font-size: small; display: flex; flex-direction: column; gap: 12px;">
                                <div>
                                    <h6>Invoice from:</h6>
                                    <h5>{{ setting?.title }}</h5>
                                    <div style="display: flex; flex-direction: column; gap: 2px;">
                                        <div style="display: flex; align-items: center; font-weight: 500;">
                                            <span>
                                                {{ setting?.email }}
                                            </span>
                                        </div>

                                        <div style="display: flex; align-items: center; font-weight: 500;" v-if="setting.account_details">
                                            <span>
                                                {{ setting?.account_details?.website }}
                                            </span>
                                        </div>

                                        <div style="display: flex; align-items: center; font-weight: 500;">
                                            <span>
                                                {{ setting?.phone }}
                                            </span>
                                        </div>

                                        <div style="display: flex; align-items: center; font-weight: 500;">
                                            <span>
                                                {{ setting?.address }}
                                            </span>
                                        </div>

                                        <div v-if="setting.account_details.bin" style="display: flex; flex-direction: row; gap: 4px;">
                                            <span style="font-weight: bold;">BIN:</span>
                                            <span style="font-weight: 500;">{{ setting?.account_details?.bin }}</span>
                                        </div>

                                        <div v-if="setting.account_details.tin" style="display: flex; flex-direction: row; gap: 4px;">
                                            <span style="font-weight: bold;">TIN:</span>
                                            <span style="font-weight: 500;">{{ setting?.account_details?.tin }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Quotation Info -->
                            <div class="invoice-info" style="font-size: small;">
                                <h5>
                                    Invoice #{{ invoiceData.invoice_id }}
                                </h5>
                                <p style="font-weight: 500;">
                                    Invoice Date:
                                    {{ parseDate(invoiceData.invoice_date) }}
                                </p>
                                <p style="font-weight: 500; margin-top: -12px;">
                                    Due date: {{ parseDate(invoiceData.due_date) }}
                                </p>
                            </div>
                        </div>

                        <div style="width: 100%; display: flex; justify-content: space-between;">
                            <!-- Client Info -->
                            <div class="client-info" style="font-size: small;">
                                <h6>Invoice to:</h6>
                                <h5 v-if="invoiceData.client.additional_info">
                                    {{ invoiceData.client.additional_info.company.name }}
                                </h5>
                                <a v-if="invoiceData.client.additional_info" :href="`mailto:${invoiceData.client.additional_info.company.email}`">
                                    {{ invoiceData.client.additional_info.company.email }}
                                </a>
                                <span v-if="invoiceData.client_address" style="width: 75%; max-width: 65ch; margin-top: 4px; margin-bottom: 4px;">
                                    {{ invoiceData.client_address }}
                                </span>
                                <span v-if="invoiceData.billing_address" style="width: 75%; max-width: 65ch; display: flex; flex-direction: column;">
                                    <span style="font-weight: bold;">Billing Address:</span>
                                    <span>{{ invoiceData.billing_address }}</span>
                                </span>
                                <span v-if="invoiceData.client.additional_info" style="width: 75%; max-width: 65ch; display: flex; flex-direction: row; gap: 4px; margin-top: 4px; margin-bottom: 4px;">
                                    <span style="font-weight: bold;">BIN:</span>
                                    <span>{{ invoiceData.client.additional_info.company.bin }}</span>
                                </span>
                                <span v-if="invoiceData.client.additional_info" style="width: 75%; max-width: 65ch; display: flex; flex-direction: row; gap: 4px;">
                                    <span style="font-weight: bold;">TIN:</span>
                                    <span>{{ invoiceData.client.additional_info.company.tin }}</span>
                                </span>
                            </div>

                            <!-- Payment Info -->
                            <div class="invoice-info" style="font-size: small;">

                                <div style="display: flex; align-items: flex-start;">
                                    <div style="display: flex; flex-direction: row; gap: 4px;" >
                                        <span class="font-weight-bold" style="font-size: 15px;">Project: </span>
                                        <span style="font-size: 15px; word-break: break-all;">{{ invoiceData?.project?.title ?? 'N/A'   }}</span>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <!-- Item table -->
                      
                        <div class="mt-4 table-container" v-if="invoiceData.details!=null">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty :items="invoiceData.details" :fields="fields">
                                        <template #cell(name)="row">
                                            <h6 style="min-width: 150px;" v-if="row.item.checkLabel">{{ row.item.name }}</h6>
                                            <p style="min-width: 150px;" v-else>{{ row.item.name }}</p>
                                        </template>
                                        <template #cell(description)="row">
                                            <div v-if="row.item.description !== null">
                                                <p style="width: 400px; word-break: break-all;">{{ truncateText(row.item.description, 45) }}</p>
                                            </div>
                                        </template>

                                
                                       
                                        <template #cell(amount)="row">
                                            <div v-if="row.item.rate">
                                                <p v-if="row.item.rate == 0"></p>
                                                <p v-else>{{ row.item.rate }}</p>
                                            </div>
                                        </template>
                                    </b-table>
                                </div>
                            </div>

                        <div style="width: 100%; display: flex; justify-content: end;">
                            <!-- Bank Info -->
                            <!-- <div class="client-info" style="font-size: small;">
                           <h6>Account Details</h6>
                           <span style="width: 75%; min-width: 65ch; font-weight: 400; font-size: 14px;">
                               Account Name: {{ setting.account_details.account_name }}
                           </span>
                           <span style="width: 75%; max-width: 65ch; font-weight: 400; font-size: 14px;">
                               Account Number: {{ setting.account_details.account_number }}
                           </span>
                           <span style="width: 75%; max-width: 65ch; font-weight: 400; font-size: 14px;">
                               Bank Name: {{ setting.account_details.bank_name }}
                           </span>
                           <span style="width: 75%; max-width: 65ch; font-weight: 400; font-size: 14px;">
                               Branch: {{ setting.account_details.branch_name }}
                           </span>
                       </div> -->

                            <!-- Payment Info -->
                            <div class="" style="font-size: small;">
                                <div class="total-item" style="min-width: 25vh; padding: 4px; border-style: solid; border-top: 0px; border-left: 0px; border-right: 0px; border-width: 1px; border-color: #e5e7eb;">
                                    <h6 style="font-weight: 500;">Total:</h6>
                                    <h6 style="text-align: right;">
                                        <span style="font-weight: 500;">
                                            {{ invoiceData.total }}
                                        </span>
                                        {{ invoiceData.currency }}
                                    </h6>
                                </div>
                                      <!-- Vat -->
                                    <div
                                        class="total-item"
                                        style="margin-top: 5px; padding: 4px; border-style: solid; border-top: 0px; border-left: 0px; border-right: 0px; border-width: 1px; border-color: #e5e7eb;"
                                        v-if="invoiceData.vat"
                                    >
                                        <div>
                                            <h6 style="font-weight: 500; margin-bottom: 0;">
                                                Vat ({{ invoiceData.vat || 0 }}%)
                                            </h6>

                                            <small>
                                                {{ invoiceData.vat_type === 'inclusive' ? 'Inc.' : 'Excl.' }}
                                            </small>
                                        </div>

                                        <h6 style="text-align: right;">
                                            {{ vatAmount }}
                                        </h6>
                                    </div>
                                <!-- Tax -->
                                    <div
                                        class="total-item"
                                        style="margin-top: 5px; padding: 4px; border-style: solid; border-top: 0px; border-left: 0px; border-right: 0px; border-width: 1px; border-color: #e5e7eb;"
                                        v-if="invoiceData.tax"
                                    >
                                        <div>
                                            <h6 style="font-weight: 500; margin-bottom: 0;">
                                                Tax ({{ invoiceData.tax || 0 }}%)
                                            </h6>

                                            <small>
                                                {{ invoiceData.tax_type === 'inclusive' ? 'Inc.' : 'Excl.' }}
                                            </small>
                                        </div>

                                        <h6 style="text-align: right;">
                                            {{ taxAmount }}
                                        </h6>
                                    </div>
                                <!-- Discount -->
                                    <div class="total-item" style="margin-top: 5px; padding: 4px; border-style: solid; border-top: 0px; border-left: 0px; border-right: 0px; border-width: 1px; border-color: #e5e7eb;" v-if="invoiceData.discount">
                                        <h6 style="font-weight: 500;">Discount ({{ invoiceData.discount ? invoiceData.discount : 0 }}%)</h6>
                                        <h6 style="text-align: right;">
                                            {{discountAmount }}
                                        </h6>
                                    </div>
                                <div class="total-item" style="margin-top: 5px; padding: 4px; border-style: solid; border-top: 0px; border-left: 0px; border-right: 0px; border-width: 1px; border-color: #e5e7eb;">
                                    <h6 style="font-weight: 500;">Subtotal:</h6>
                                    <h6 style="text-align: right; color: brown;">
                                        <span style="font-weight: 500;">
                                            {{ formatNumber(invoiceData.subtotal) }}
                                        </span>
                                        {{ invoiceData.currency }}
                                    </h6>
                                </div>
                            </div>
                        </div>

                        <div class="mt-4 other-info-container" v-if="invoiceData.remarks">
                            <h6 style="padding-right: 10px;">Remarks:</h6>
                            <p style="padding:8px 0px; font-size: small;">
                                {{ invoiceData.remarks }}
                            </p>
                        </div>

                        <div style="display: flex; justify-content: flex-start; margin-top: 10px">
                            <div style="display: flex; flex-direction: column; align-items: flex-start;">
                                <img style="height: auto; width: auto; max-height: 100px; max-width: 100px;" :src="host+setting.authorized_signature" alt="" v-if="showSignature == true" />
                                <p style="border-style: solid; border-bottom: 40px; border-left: 0; border-right: 0; border-width: 1px; border-color: #d1d5db; padding: 2px 8px 4px; margin-top: 12px; font-size: small; align-self: flex-start;">
                                    Authorized signature
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="loader-box">
                    <div class="loader-10"></div>
                </div>
            </div>

        </div>

        <div class="col-xl-4">
            <px-card>
                <div class="p-3 w-100 content-container-attahment" v-if="!loading && !error">
                    <div class="d-flex justify-content-between" style="margin-bottom: 4px;">
                        <h6>Supporting Documents</h6>
                        <feather type="plus-square" size="22px" style="color: #ff595d; cursor: pointer;" v-b-modal.modal-scrollable-add-document v-b-tooltip.hover title="Add Documents"> </feather>
                    </div>

                    <b-table show-empty sticky-header :items="invoiceData.invoice_attach" :fields="Attachment" head-variant="light">
                        <template #cell(index)="data">
                           {{ data.index + 1 }}
                        </template>

                        <template #cell(title)="data">
                            <a :href="host+data.item.invoice_attachment" target="_blank" style="word-break: break-all; width: 100px" v-if="data.item.attach_title">{{ data.item.attach_title ? data.item.attach_title : '--'  }}

<br/>
<small v-if="data.item.note" style="font-style: italic;">Note:{{data.item.note ? truncateText(data.item.note, 30) : '' }}</small>
                            </a>
                            <!-- <a :href="host+data.item.invoice_attachment" target="_blank" style="word-break: break-all; width: 100px" v-else>--</a> -->
                        </template>

                        <template #cell(action)="data">
                            <div style="display: flex; flex-direction: row; gap:10px">
                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover title="Delete" @click="deleteAttach(data.item.id)"></feather>
                            </div>
                        </template>
                    </b-table>
                </div>

                <div class="p-2" v-else>
                    <div class="loader-box">
                        <div class="loader-10"></div>
                    </div>
                </div>
            </px-card>

            <px-card>
                <div class="p-3 w-100 content-container-attahment" v-if="!loading && !error">
                    <div>
                        <div class="d-flex justify-content-between" style="margin-bottom: 4px;">
                            <h6>Bank Details</h6>
                        </div>

                        <b-table show-empty sticky-header :items="bank_accounts" :fields="banks" head-variant="light">
                            <template #cell(index)="data">
                               {{ data.index + 1 }}
                            </template>

                            <template #cell(account_number)="data">
                                <router-link :to="'/finance-and-accounts/banking-info/details/'+ data.item.id" class="link-style"><span>{{ data.item.account_number }}</span></router-link>
                            </template>
                        </b-table>
                    </div>
                </div>
                <div class="p-2" v-else>
                    <div class="loader-box">
                        <div class="loader-10"></div>
                    </div>
                </div>
            </px-card>

            <px-card>
                <div class="p-3 w-100 content-container-attahment" v-if="!loading && !error">
                    <div>
                        <div class="d-flex justify-content-between" style="margin-bottom: 4px;">
                            <h6>Payments</h6>
                        </div>

                        <b-table show-empty sticky-header :items="paymentList" :fields="payments" head-variant="light">
                            <template #cell(index)="data">
                               {{ data.index + 1 }}
                            </template>

                            <template #cell(status)="row">
                                <span v-if="row.value == 'APPROVED'">
                                    <b-badge variant="success">{{ row.value }}</b-badge>
                                </span>
                                <span @click="getStatus(row.item, row.item.id)" v-if="row.value == 'PENDING'">
                                    <b-badge variant="primary" v-b-modal.modal-prevent-closing>{{ row.value }}</b-badge>
                                </span>
                                <span @click="getStatus(row.item, row.item.id)" v-if="row.value == 'REJECTED'">
                                    <b-badge variant="danger" v-b-modal.modal-prevent-closing>{{ row.value }}</b-badge>
                                </span>
                            </template>
                        </b-table>
                    </div>
                </div>
                <div class="p-2" v-else>
                    <div class="loader-box">
                        <div class="loader-10"></div>
                    </div>
                </div>
            </px-card>
        </div>
    </div>

    <!-- Project Attachment Create -->
    <b-modal id="modal-scrollable-add-document" ref="modal" title="Add document" @ok="handleAttachOk">
        <form ref="form" @submit.stop.prevent="handleAttahmentSubmit">
             <div class="row">
    <div class="col-sm-12">
        <div class="form-group">
            <label>Supporting note </label>
            <input class="form-control" type="text" placeholder="Enter supporting note ..." v-model="add_attachment.note">
        </div>
    </div>
</div>

            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Upload Supporting Documnets</label>
                        <b-form-file placeholder="Choose files  or drop them here..." drop-placeholder="Drop file here..." @change="uploadAttachFile"></b-form-file>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Payment Status Change -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Update Payment Status" @ok="handlePaymentStatusOk">
        <form ref="form" @submit.stop.prevent="handlePayementStatusSubmit">
            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="selectedStatus" :options="statuses"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Payment approved -->
    <!-- <b-modal id="modal-center-approved" centered hide-header @ok="handlePayementSubmit">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to approved this payment?</div>
    </b-modal> -->

    <b-modal id="modal-prevent-status" ref="modal" title="Add Transaction" size="xl" hide-footer>
        <paymentApproveVue :amount="this.approved_status" :paymentType="'INVOICE'" />
    </b-modal>

</div>
</template>

<script>
import {
    mapState
} from "vuex";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
// import logo from "src/assets/images/logo/login.png";
import {
    myHost
} from "../../../_helpers/host";

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import paymentApproveVue from '../accounts/payments/payment-approve.vue'
export default {
    props: ["id", "download"],
    components: {
        paymentApproveVue
    },
    data() {
        return {
            showPage: true,
            showLogo: true,
            host: myHost.host,
            add_attachment: {
                invoice_attachment: null,
                invoice_id: '',
                note:null,
            },

            Attachment: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: true
                }
            ],

            fields: [
                {
                    key: 'name',
                    label: 'Item',
                    sortable: false
                },
                {
                    key: 'description',
                    label: 'Description',
                    sortable: false
                },
                {
                    key: 'quantity',
                    label: 'Quantity',
                    sortable: false
                },
                {
                    key: 'unit_price',
                    label: 'Unit Price',
                    sortable: false
                },
                {
                    key: 'amount',
                    label: 'Amount',
                    sortable: false
                }
            ],
            payments: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'requested_by.username',
                    label: 'Requested By',
                    sortable: true
                },
                {
                    key: 'paid_amount',
                    label: 'Request Amount',
                    sortable: true
                },

                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                }
            ],

            banks: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'bank_name',
                    label: 'Bank',
                    sortable: true
                },
                {
                    key: 'account_number',
                    label: 'Account No',
                    sortable: true
                }
            ],

            approved_status: {
                update_id: '',
                amount: null,
                detail_id: null,
            },

            downloadPdf: false,

            invoice: '',
            statuses: ['APPROVED', 'PENDING', 'REJECTED'],
            selectedStatus: '',

            showSignature: false,
            showLetterHead: true,
        };
    },

    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },

        generatePDF() {
            this.showPage = false;
            const element = this.$refs.printDiv;
            const pdf = new jsPDF('p', 'pt', 'letter');

            // Background and logo image settings
            const backgroundImageUrl = this.showLetterHead ? this.host + this.setting.letterpad : null;
            const logoImageUrl = this.showLogo ? this.host + this.setting.logo : null;

            const backgroundImg = new Image();
            const logoImg = new Image();

            const loadImage = (img, src) => {
                return new Promise((resolve, reject) => {
                    if (!src) {
                        resolve();
                    } else {
                        img.crossOrigin = 'anonymous'; // Ensure CORS is properly set if needed
                        img.src = src;
                        img.onload = () => resolve(img);
                        img.onerror = reject;
                    }
                });
            };

            Promise.all([loadImage(backgroundImg, backgroundImageUrl), loadImage(logoImg, logoImageUrl)]).then((images) => {
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();

                // Content padding and margin
                const contentPaddingTop = 0; // Adjust the top padding as needed
                const contentPaddingBottom = 0; // Adjust the bottom padding as needed
                const contentMargin = 0; // Margin between content and background image

                let positionY = contentPaddingTop; // Start position at the top padding
                let contentHeight = element.offsetHeight;

                const addContent = () => {
                    pdf.html(element, {
                        x: contentMargin,
                        y: positionY + contentMargin,
                        html2canvas: {
                            scale: 0.6,
                            useCORS: true // Use CORS for capturing images
                        },
                        callback: () => {
                            const filename = `${this.invoiceData.invoice_id}.pdf`;
                            pdf.save(filename);
                            this.showPage = true;
                        },
                        margin: [80, 0, 80, 0],
                    });
                };

                const addImages = () => {
                    if (this.showLetterHead) {
                        pdf.addImage(backgroundImg, 'JPEG', 0, 0, pdfWidth, pdfHeight);
                    }
                    if (this.showLogo) {
                        const logoWidth = logoImg.width; // Use the natural width of the logo image
                        const logoHeight = 30; // Use the natural height of the logo image
                        const logoMargin = 50; // Right margin for the logo
                        const logoX = pdfWidth - logoWidth - logoMargin;
                        const logoY = 18; // Margin from top
                        pdf.addImage(logoImg, 'JPEG', logoX, logoY, logoWidth, logoHeight);
                    }
                };

                addContent();
                addImages();

                let pageCount = Math.ceil(contentHeight / 794);
                for (let i = 1; i < pageCount; i++) {
                    pdf.addPage();
                    addImages();
                }
            }).catch((error) => {
                console.error('Error loading images:', error);
            });
        },
        showPDF() {
            this.showPage = false;
            const element = this.$refs.printDiv;
            const pdf = new jsPDF('p', 'pt', 'letter');

            // Background and logo image settings
            const backgroundImageUrl = this.showLetterHead ? this.host + this.setting.letterpad : null;
            const logoImageUrl = this.showLogo ? this.host + this.setting.logo : null;

            const backgroundImg = new Image();
            const logoImg = new Image();

            const loadImage = (img, src) => {
                return new Promise((resolve, reject) => {
                    if (!src) {
                        resolve();
                    } else {
                        img.crossOrigin = 'anonymous'; // Ensure CORS is properly set if needed
                        img.src = src;
                        img.onload = () => resolve(img);
                        img.onerror = reject;
                    }
                });
            };

            Promise.all([loadImage(backgroundImg, backgroundImageUrl), loadImage(logoImg, logoImageUrl)]).then((images) => {
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();

                // Content padding and margin
                const contentPaddingTop = 0; // Adjust the top padding as needed
                const contentPaddingBottom = 0; // Adjust the bottom padding as needed
                const contentMargin = 0; // Margin between content and background image

                let positionY = contentPaddingTop; // Start position at the top padding
                let contentHeight = element.offsetHeight;

                const addContent = () => {
                    pdf.html(element, {
                        x: contentMargin,
                        y: positionY + contentMargin,
                        html2canvas: {
                            scale: 0.6,
                            useCORS: true // Use CORS for capturing images
                        },
                        callback: () => {
                            // const filename = `${this.invoiceData.invoice_id}.pdf`;

                            // Convert the PDF to a Blob and create an object URL
                            const pdfBlob = pdf.output('blob');
                            const pdfUrl = URL.createObjectURL(pdfBlob);

                            // Open the PDF in a new tab
                            window.open(pdfUrl);

                            this.showPage = true;
                        },
                        margin: [80, 0, 80, 0],
                    });
                };

                const addImages = () => {
                    if (this.showLetterHead) {
                        pdf.addImage(backgroundImg, 'JPEG', 0, 0, pdfWidth, pdfHeight);
                    }
                    if (this.showLogo) {
                        const logoWidth = logoImg.width; // Use the natural width of the logo image
                        const logoHeight = 30; // Use the natural height of the logo image
                        const logoMargin = 50; // Right margin for the logo
                        const logoX = pdfWidth - logoWidth - logoMargin;
                        const logoY = 18; // Margin from top
                        pdf.addImage(logoImg, 'JPEG', logoX, logoY, logoWidth, logoHeight);
                    }
                };

                addContent();
                addImages();

                let pageCount = Math.ceil(contentHeight / 794);
                for (let i = 1; i < pageCount; i++) {
                    pdf.addPage();
                    addImages();
                }
            }).catch((error) => {
                console.error('Error loading images:', error);
            });
        },
        toggleLogo() {
            this.showLogo = !this.showLogo;
        },
        formatNumber(number) {
            return Number(number.toFixed(2)).toLocaleString('en-US', {
                minimumFractionDigits: 2
            });
        },
        toggleLetterHead() {
            this.showLetterHead = !this.showLetterHead;
        },

        toggleSignature() {
            this.showSignature = !this.showSignature;
        },

        // getStatus(status, id) {
        //     this.invoice = id
        //     this.selectedStatus = status
        // },

        getStatus(status, id) {
            this.approved_status.amount = status.paid_amount
            this.approved_status.detail_id = status.invoice.id
            this.approved_status.update_id = id
            this.selectedStatus = status.status
        },

        handlePaymentStatusOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handlePayementStatusSubmit()
        },

        handlePayementStatusSubmit() {
            if (this.selectedStatus === 'APPROVED') {

                this.$nextTick(() => {
                    this.$bvModal.show('modal-prevent-status')
                })

            } else {
                this.$store.dispatch("payments/updateInvoicePaymentStatus", {
                    id: this.approved_status.update_id,
                    status: this.selectedStatus,
                    detail_id:this.approved_status.detail_id
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });

                        

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })

                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing')
                })
            }
        },

        // handlePayementSubmit() {
        //     this.$store.dispatch("invoice/updatePaymentStatus", {
        //         detail_id: this.invoiceData.id,
        //         id: this.invoice,
        //         status: this.selectedStatus
        //     }).then(response => {
        //         if (response.code == 200) {
        //             Swal.fire({
        //                 title: "Success!",
        //                 text: response.response,
        //                 icon: "success"
        //             });

        //             this.payment = null

        //         } else {
        //             Swal.fire({
        //                 title: "Error!",
        //                 text: response.response,
        //                 icon: "error"
        //             });
        //         }
        //     })

        //     this.$nextTick(() => {
        //         this.$bvModal.hide('modal-prevent-closing-status')
        //     })
        // },

        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

        handleAttachOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleAttahmentSubmit()
        },

        handleAttahmentSubmit() {
            this.add_attachment.invoice_id = this.invoiceData.id
            this.$store.dispatch("invoice/addInvoiceAttachment", {
                attachment: this.add_attachment,
                invoice_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.add_attachment.invoice_attachment = null
                    this.add_attachment.note = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable-add-document')
            })
        },

        deleteAttach(id) {
            this.$store.dispatch("invoice/deleteAttachmentFromInvoice", {
                id: id,
                invoice_id: this.$route.params.id,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        uploadAttachFile(e) {
            this.add_attachment.invoice_attachment = e.target.files[0]
        },

        printPdf(section) {
            this.downloadPdf = true;

            const printContents = document.getElementById(section).innerHTML;
            const originalContents = document.body.innerHTML;

            const wrappedPrintContents = `<div class="page">${printContents}</div>`;

            document.body.innerHTML = wrappedPrintContents;

            window.print();

            document.body.innerHTML = originalContents;
            location.reload();
        },

        parseDate(date) {
            return new Date(Date.parse(date)).toLocaleDateString("en-US", {
                year: "numeric",
                day: "numeric",
                month: "short",
            });
        },

        editInvoice(id) {
            this.$router.push({
                path: `/finance-and-accounts/finance/invoice/edit/${id}`
            });
        }
    },

    computed: {
        ...mapState({
            invoiceData: state => state.invoice.invoice_detail,
            setting: state => state.organization.organization_setting,
            paymentList: state => state.invoice.invoicePaymentList,
            bank_accounts: state => state.bank.active_accounts,

            loading: state => state.invoice.submitLoading,
            error: state => state.invoice.submitError

        }),

        additionalStyle() {
            return this.showLetterHead ? {
                'background-image': `url(${this.host}${this.setting.letterpad})`,
                'background-size': '100% 100%',
                'background-position': 'center center',
                'background-repeat': 'no-repeat',
            } : {};
        },

       
        basePrice() {
            if (
                !this.invoiceData?.total ||
                (!this.invoiceData?.vat_type &&
                !this.invoiceData?.tax_type)
                ) {
                    return 0;
                }

            const total = Number(this.invoiceData.total);
            const vat = Number(this.invoiceData.vat || 0);
            const tax = Number(this.invoiceData.tax || 0);

            let divisor = 1;

            if (this.invoiceData.vat_type === "inclusive") {
                divisor += vat / 100;
            }

            if (this.invoiceData.tax_type === "inclusive") {
                divisor += tax / 100;
            }

            const base = total / divisor;

            return Math.round((base + Number.EPSILON) * 100) / 100;
        },

        taxAmount() {
            if (
                !this.invoiceData?.tax ||
                !this.invoiceData?.total
            ) {
                return 0;
            }

            const tax = Number(this.invoiceData.tax);

            return (
                Math.round(
                    ((this.basePrice * tax) / 100 + Number.EPSILON) * 100
                ) / 100
            );
        },

        vatAmount() {
            if (
                !this.invoiceData?.vat ||
                !this.invoiceData?.total
            ) {
                return 0;
            }

            const vat = Number(this.invoiceData.vat);

            return (
                Math.round(
                    ((this.basePrice * vat) / 100 + Number.EPSILON) * 100
                ) / 100
            );
        },
        discountAmount() {
            if (!this.invoiceData?.total) {
                return 0;
            }

            const total = Number(this.invoiceData.total);
            const discount = Number(this.invoiceData.discount || 0);

            const discountAmount = (total * discount) / 100;

            return (
                Math.round((discountAmount + Number.EPSILON) * 100) / 100
            );
        }


    },

    mounted() {
        this.$store.dispatch("invoice/fetchInvoiceDetail", this.$route.params.id).then(() => {
            this.$store.dispatch("invoice/fetchInvoicePaymentByInvoice", this.invoiceData.id)
        })
        this.$store.dispatch("organization/fetchOrganizationSettings")
        this.$store.dispatch("bank/fetchActiveBankAccounts")
    }
};
</script>

<style scoped>
.content-container {
    background-color: white;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 20px 60px;
}

.imgSection {
    position: absolute;
    top: 32px;
    right: 58px;
}

.content-container-attahment {
    background-color: white;

    padding: 10px;

}

.invoice-header,
.client-section {
    display: flex;
    justify-content: space-between;
    align-items: start;
    margin-bottom: 48px;
}

.company-info,
.client-info {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: start;
}

.payment-info {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-items: flex-end;
    align-items: flex-end;
}

.total-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: start;
}

.invoice-info {
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: end;
}

.logo-img {
    object-fit: cover;
    object-position: center;
}

.table-container {
    width: 100%;
    font-size: small;
    color: black;
}

.total-container {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    align-self: flex-end;
    margin-top: 20px;
    margin-bottom: 32px;
}

.other-info-container {
    display: flex;
    flex-direction: column;
    width: 100%;
}

/* @media print {
        html,
        body {
            width: 210mm;
            height: 297mm;
        }

        .content-container {
            margin: 0;
            width: initial;
            min-height: initial;
        }
    } */

.invoice-container {
    width: 100%;
    max-width: 1280px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
}

@media print {
    .invoice-container {
        display: none;
        visibility: hidden;
    }

    .signature-btn {
        display: none;
        visibility: hidden;
    }
}

@media screen and (max-width: 639px) {

    .content-container {
        background-color: white;
        display: flex;
        flex-direction: column;
        position: relative;
        padding: 20px 20px;
    }

    .invoice-header {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        margin-bottom: 20px;
    }

    .invoice-info {
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: end;
    }

    .client-section {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 20px;
        margin-bottom: 20px;
    }

    .payment-info {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-items: flex-start;
        align-items: flex-start;
    }

    .total-container {
        width: 80%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        align-self: flex-end;
        margin-top: 20px;
        margin-bottom: 32px;
    }
}

#print {
    width: 1020px;
    padding: 0in 0in;
    box-sizing: border-box;

}
</style>
